import {
  IonCard,
  IonCardContent,
  IonItem,
  IonToast,
  IonSegment,
  IonSegmentButton,
  IonInput,
  IonButton,
  IonLabel,
  IonCardHeader,
  IonContent,
  IonPage,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { Preferences } from "@capacitor/preferences";
import axios from "axios";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { mk_ion_header } from "../functions/mk_ion_header";
import { logout } from "../functions/logout";

export default function Login() {
  const { appBuildVersion, appBuildVersionChange, appServer, appServerChange, appLoggedInChange, appTokenChange, appVersion, appVersionChange } = useContext(DataContext);
  const [segment, setSegment]: any = useState("login");
  const [loginUser, setLoginUser]: any = useState("");
  const [domain] = useState("solufind");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [loginPass, setLoginPass]: any = useState("");
  const [loginTry, setLoginTry] = useState(false);

  useEffect(() => {
    if (loginTry === true) {
      fetchLogin();
    } else setLoginTry(false);
  }, [loginTry]);

  useEffect( () => {
    fetch( '/version.txt' )
      .then( ( res ) => {
        return res.text();
      } )
      .then( ( version ) => {
        appVersionChange( version );
        appBuildVersionChange( version.split( '.' ).slice( -1 )[ 0 ] );
      } );
  }, [] );

  const register = async () => {
    Preferences.set({
      key: "senioren.server",
      value: appServer,
    });
  };

  const getMittag = async (token: string) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
    };

    await fetch(appServer + "/funktionen/api2/senioren/mittag.php?appBuildVersion=" + appBuildVersion, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        let storagedata = {
          key: "senioren.mittag",
          value: JSON.stringify(result),
        };

        await Preferences.set(storagedata);
      });
  };

  const getAbend = async (token: string) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
    };
    await fetch(appServer + "/funktionen/api2/senioren/abend.php", requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        let storagedata = {
          key: "senioren.abend",
          value: JSON.stringify(result),
        };

        await Preferences.set(storagedata);
      });
  };

  const getFrueh = async (token: string) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
    };

    await fetch(appServer + "/funktionen/api2/senioren/frueh.php", requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        let storagedata = {
          key: "senioren.frueh",
          value: JSON.stringify(result),
        };

        await Preferences.set(storagedata);
      });
  };

  const getBewohner = async (token: string) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
    };
    await fetch(appServer + "/funktionen/api2/senioren/bewohner.php", requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        let storagedata = {
          key: "senioren.bewohner",
          value: JSON.stringify(result),
        };

        await Preferences.set(storagedata);
      });
  };

  const getData = async (token: string) => {
    // let token = await checkToken() ;
    await getFrueh(token);
    await getMittag(token);
    await getAbend(token);
    await getBewohner(token);
  };

  const fetchLogin = () => {
    //var axios = require("axios");
    var data = {
      usr: loginUser,
      pwd: loginPass,
      domain: domain,
    };

    var config = {
      method: "post",
      url: appServer + "/funktionen/api2/senioren/login.php?appBuildVersion=" + appBuildVersion,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(async function (response) {
        if (response.data) {
          let storagedata = {
            key: "senioren.token",
            value: response.data.token,
          };
          Preferences.set(storagedata);
          if (response.data.status === 200) {
            if ( response.data.satellite !== '' ) {
              let my_url =
                window.location.protocol === 'http:'
                  ? response.data.satellite.replace( 'https://', window.location.protocol + '//' )
                  : response.data.satellite;
              await Preferences.set( {
                key: 'senioren.server',
                value: my_url
              } );
              alert(
                '\nSie haben versucht sich mit einer ungültigen Serverangabe anzumelden. Der Anmeldeserver wurde automatisch korrigiert, aus Sicherheitsgründen müssen Sie Ihr Passwort erneut eingeben.\n'
              );
              logout() ;
              return ;
            }
            appLoggedInChange(true);
            appTokenChange(response.data.token);
            await getData(response.data.token);
          }
        }
      })
      .finally(function () {
        setToastMessage( '' ) ;
        setToast(false);
      })
      .catch(function (error) {
        if (error.code === 'ERR_BAD_REQUEST') {
          if (error.response.data && error.response.data.status === 401) {
            setToastMessage( 'Ungültiger Benutzername oder falsches Passwort' ) ;
            setToast(true);
            setLoginTry(false);
            return ;
          }
          setToastMessage( 'Verbindungsfehler - Eingaben prüfen und erneut versuchen' ) ;
          setToast(true);
          setLoginTry(false);
          return ;
        }
        if (error.code === 'ERR_BAD_RESPONSE') {
          setToastMessage( 'Verbindungsfehler - erneut versuchen' ) ;
          setToast(true);
          setLoginTry(false);
          return ;
        }
        if (error.code === 'ERR_NETWORK') {
          setToastMessage( 'Verbindungfehler - Angabe "Server" unter "Einstellungen" und ggf. Internet-Verbindung prüfen' ) ;
          setToast(true);
          setLoginTry(false);
          return ;
        }
        setToastMessage( 'Verarbeitungsfehler - Eingaben prüfen und erneut versuchen' ) ;
        setToast(true);
        setLoginTry(false);
        return ;
      });
  };

  const set_segment = (e: any) => {
    setSegment(e.target.value);
  };

  return (
    <IonPage>
      {mk_ion_header("Login")}
      <IonContent fullscreen>
        {mk_ion_header("Login", "large")}
        <IonCard>
          {/* <IonCardContent>            
            
            Bitte nutzen Sie das nachfolgende Formular zur Anmeldung. Geben Sie dafür bitte ihren Benutzernamen und das Passwort ein. Beide Informationen wurden Ihnen vorab per eMail bereitgestellt.
            
            </IonCardContent> */}
        </IonCard>
        <IonCard>
          <IonCardHeader></IonCardHeader>
          <IonCardContent>
            <IonSegment value={segment} onClick={(e) => set_segment(e)}>
              <IonSegmentButton value="login">
                <IonLabel>Login</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="register">
                <IonLabel>Einstellungen</IonLabel>
              </IonSegmentButton>
            </IonSegment>

            {segment && segment === "login" ? (
              <>
                <IonItem>
                  <IonLabel position="floating">Benutzername</IonLabel>
                  <IonInput placeholder="Name" onIonChange={(e) => setLoginUser(e.target.value)} value={loginUser}></IonInput>
                </IonItem>
                <IonItem>
                  <IonLabel position="floating">Passwort</IonLabel>
                  <IonInput placeholder="Passwort" type="password" onIonChange={(e) => setLoginPass(e.target.value)} value={loginPass}></IonInput>
                </IonItem>
                <IonButton expand="full" onClick={() => setLoginTry(true)}>
                  Anmelden
                </IonButton>
              </>
            ) : segment && segment === "register" ? (
              <>
                <IonItem>
                  <IonLabel position="floating">Server</IonLabel>
                  <IonInput placeholder="Server" onIonChange={(e) => appServerChange(e.target.value)} value={appServer}></IonInput>
                </IonItem>

                <IonButton expand="full" onClick={() => register()}>
                  speichern
                </IonButton>
              </>
            ) : (
              ""
            )}
            <IonItem>
              <IonLabel>Version 1.12.009.5611</IonLabel>
            </IonItem>
          </IonCardContent>
        </IonCard>

        <IonToast isOpen={toast} color="danger"
          buttons={[
            {
              text: 'OK',
              role: 'cancel'
            },
          ]}
          onDidDismiss={() => setToast(false)} message={ toastMessage } duration={10000} />
      </IonContent>
    </IonPage>
  );
}
